<template>
  <transition name="modal">
    <div v-if="visible"
         class="fixed inset-0 z-50 flex items-center justify-center p-4">
      <!-- Backdrop -->
      <div class="absolute inset-0 bg-black/60 backdrop-blur-sm" @click="onCancel"/>

      <!-- Dialog -->
      <div class="relative bg-surface dark:bg-dark-700 rounded-card shadow-dropdown
                  w-full max-w-sm border border-primary-100 dark:border-dark-600 font-sans">

        <!-- Header -->
        <div class="flex items-center justify-between px-5 pt-5 pb-4
                    border-b border-primary-50 dark:border-dark-600">
          <div class="flex items-center gap-3">
            <div class="w-8 h-8 rounded-xl bg-accent-400/15 flex items-center justify-center flex-shrink-0">
              <i class="pi pi-exclamation-triangle text-accent-600 dark:text-accent-400 text-[14px]"/>
            </div>
            <h3 class="font-display text-[15px] font-bold text-dark-700 dark:text-white">
              {{ title }}
            </h3>
          </div>
          <button @click="onCancel"
                  class="w-7 h-7 rounded-lg flex items-center justify-center
                         text-muted dark:text-muted-light
                         hover:bg-primary-50 dark:hover:bg-dark-600
                         transition-colors duration-150">
            <i class="pi pi-times text-[12px]"/>
          </button>
        </div>

        <!-- Message -->
        <div class="px-5 py-5">
          <p class="text-[13px] text-dark-400 dark:text-white/70 leading-relaxed">
            {{ message }}
          </p>
        </div>

        <!-- Actions -->
        <div class="flex justify-end gap-2 px-5 pb-5">
          <button @click="onCancel"
                  class="px-4 py-2 rounded-xl text-[13px] font-semibold
                         bg-primary-50 dark:bg-dark-600
                         border border-primary-100 dark:border-dark-500
                         text-dark-400 dark:text-white/70
                         hover:bg-primary-100 dark:hover:bg-dark-500
                         transition-colors duration-150">
            Cancel
          </button>
          <button @click="onConfirm"
                  class="px-5 py-2 rounded-xl text-[13px] font-bold
                         bg-primary-400 text-white
                         hover:bg-primary-600 hover:-translate-y-0.5
                         shadow-teal transition-all duration-150">
            Confirm
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "CustomConfirmDialog",
  props: {
    visible: { type: Boolean, required: true },
    title:   { type: String,  default: "Confirmation" },
    message: { type: String,  default: "Are you sure you want to proceed?" },
  },
  emits: ["confirm", "cancel"],
  methods: {
    onConfirm() { this.$emit("confirm"); },
    onCancel()  { this.$emit("cancel");  },
  },
};
</script>

<style scoped>
.modal-enter-active, .modal-leave-active { transition: opacity 0.2s ease; }
.modal-enter-from, .modal-leave-to { opacity: 0; }
</style>
